module.exports = __webpack_public_path__ + "media/images/client-28-d1ec5ff06ef8d2c0dd997bf218dba4b4.png";